import React, { useState, useCallback } from "react";
import { Layout, Drawer } from "antd";
import { useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import HeaderBar from "../components/HeaderBar";

const { Content } = Layout;

function MainLayout({ children }) {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [mobile, setMobile] = useState(() => window.innerWidth < 992);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const currentPath = location.pathname;

  const handleBreakpoint = useCallback((broken) => {
    setMobile(broken);
    setCollapsed(broken);
  }, []);

  const handleDrawerClose = useCallback(() => {
    setDrawerOpen(false);
  }, []);

  return (
    <Layout className="app-shell">
      {/* Desktop sidebar */}
      {!mobile && (
        <Sidebar
          collapsed={collapsed}
          currentPath={currentPath}
          onCollapse={(value) => setCollapsed(value)}
          onBreakpoint={handleBreakpoint}
        />
      )}

      {/* Mobile drawer sidebar */}
      <Drawer
        placement="left"
        open={drawerOpen}
        onClose={handleDrawerClose}
        width={260}
        closable={false}
        styles={{ body: { padding: 0 } }}
        className="mobile-sidebar-drawer"
      >
        <Sidebar
          collapsed={false}
          currentPath={currentPath}
          onCollapse={() => {}}
          onBreakpoint={() => {}}
          onNavigate={handleDrawerClose}
        />
      </Drawer>

      <Layout>
        <HeaderBar
          collapsed={collapsed}
          mobile={mobile}
          onToggle={() => {
            if (mobile) {
              setDrawerOpen((prev) => !prev);
            } else {
              setCollapsed((prev) => !prev);
            }
          }}
        />

        <Content className="app-content">
          <div className="content-panel">{children}</div>
        </Content>
      </Layout>
    </Layout>
  );
}

export default MainLayout;
